import { render, staticRenderFns } from "./CustomCompanyOverridesDF.vue?vue&type=template&id=bcdd5c1c"
import script from "./CustomCompanyOverridesDF.vue?vue&type=script&lang=ts"
export * from "./CustomCompanyOverridesDF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports